const t = "Nhấn Tab để chuyển đến cửa sổ bật lên", n = {
  triggerHint: t
};
export {
  n as default,
  t as triggerHint
};
